import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { dateInputYMD, randomBetweenToNumber } from "../../../Common/Function";
import { Get, Set } from "../../../../Request";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

export const useCard = () => {
  const dispatch = useDispatch();
  const { basket, user } = useSelector(state => state);
  const navigate = useNavigate();
  const [loading, setLoading] = useState({ offer: false, reserve: false });
  const [code, setCode] = useState();
  const [balance, setBalance] = useState("loading");
  const [kind, setKind] = useState("gateway");
  const [userInfo, setUserInfo] = useState(null);
  const [ntCodeStatus, setNtCodeStatus] = useState(null);
  const [checkTrems, setCheckTrems] = useState(false);

  useEffect(() => {
    getBalance();

    let userStorage = localStorage.getItem("user");
    if (userStorage != undefined && userStorage != "undefined" && userStorage != null) {
      userStorage = JSON.parse(userStorage)
      setUserInfo(userStorage)
      if (userStorage.national_code) {
        setNtCodeStatus(userStorage.national_code)
      }
    }
  }, [])

  const renderBasketStatus = (type, isChild) => {
    let status = true;
    const { time } = basket;
    switch (type) {
      case "+":
        if (time.capacity) {
          if (+time.capacity === +basket.count) {
            status = false;
          }
        } else {
          status = true;
        }
        break;
      case "-":
        if (isChild) {
          if (+basket.childcount === 0) {
            status = false;
          }
        }
        else {
          if (+basket.count === 1) {
            status = false;
          }
        }
        break;
      default:
        break;
    }
    return status;
  };
  const changeCount = async (type, isChild) => {

    let newBasket = { ...basket, offer: {} };
    switch (type) {
      case "+":
        if (isChild) {
          if (renderBasketStatus("+", true)) {
            newBasket.childcount = newBasket.childcount + 1;
          }
        }
        else {
          if (renderBasketStatus("+")) {
            newBasket.count = newBasket.count + 1;
          }
        }
        break;
      case "-":
        if (isChild) {
          if (renderBasketStatus("-", true)) {
            newBasket.childcount = newBasket.childcount - 1;
          }
        }
        else {
          if (renderBasketStatus("-")) {
            newBasket.count = newBasket.count - 1;
          }
        }
        break;
      default:
        break;
    }
    await dispatch({
      local_storage: {
        key: "basket",
        value: newBasket,
      },
      type: "SET",
      payload: { basket: newBasket },
    });
  };
  const clearBasket = async () => {
    await dispatch({
      local_storage: {
        key: "basket",
        value: {},
      },
      type: "SET",
      payload: { basket: {} },
    });
    navigate(-1);
  };
  const createPartners = async () => {
    const { count } = basket;
    let otherpeopel = [];
    if (basket.otherpeopel) {
      if (basket.otherpeopel.length === basket.count) {
        otherpeopel = [...basket.otherpeopel];
      } else if (basket.otherpeopel.length > basket.count) {
        otherpeopel = [...basket.otherpeopel];
        otherpeopel.pop(basket.otherpeopel.length - basket.count);
      } else {
        otherpeopel = [...basket.otherpeopel];
        [...Array(basket.count - basket.otherpeopel.length)].map(() => {
          otherpeopel.push({
            fullname: "",
            mobile: "",
            national_code: "",
            id: randomBetweenToNumber(),
          });
        });
      }
    } else {
      otherpeopel = [...Array(count)].map((id, count) => {
        if (count === 0 && user) {
          return {
            fullname: user.fullname,
            mobile: user.mobile,
            national_code: user.national_code,
            self: true,
            id: randomBetweenToNumber(),
          };
        }
        return {
          fullname: "",
          mobile: "",
          national_code: "",
          id: randomBetweenToNumber(),
        };
      });
    }

    await dispatch({
      local_storage: {
        key: "basket",
        value: { ...basket, otherpeopel, step: 2 },
      },
      type: "SET",
      payload: { basket: { ...basket, otherpeopel, step: 2 } },
    });
  };
  const changeStep = async step => {
    await dispatch({
      local_storage: {
        key: "basket",
        value: { ...basket, step },
      },
      type: "SET",
      payload: { basket: { ...basket, step } },
    });
  };
  const addPromise = async () => {
    await dispatch({
      local_storage: {
        key: "basket",
        value: { ...basket, promise: !basket.promise },
      },
      type: "SET",
      payload: { basket: { ...basket, promise: !basket.promise } },
    });
  };
  const addBall = async () => {
    await dispatch({
      local_storage: {
        key: "basket",
        value: { ...basket, reqball: !basket.reqball },
      },
      type: "SET",
      payload: { basket: { ...basket, reqball: !basket.reqball } },
    });
  };

  const getBalance = async () => {
    const data = await Get({ url: "/wallet/show" });
    setBalance(data.wallet.amount)
  };

  const storeReserve = async kindF => {
    setLoading({ reserve: true });
    // order/new_contractual_reserve

    if (!ntCodeStatus) {
      toast.error("لطفا کد ملی را وارد کنید");
      setLoading({ reserve: false });
      return;
    }
    else {
      if (!userInfo.national_code) {
        const newUser = {
          ...userInfo,
          national_code: ntCodeStatus
        }
        setUserInfo(newUser);
        dispatch({
          local_storage: {
            key: "user",
            value: newUser,
          },
          type: "SET",
        });
        await Get({ url: "/client/profile_update", data: { national_code: ntCodeStatus } });
      }
    }
    if (!basket.promise) {
      toast.error("لطفا قوانین باشگاه را تایید کنید");
      setLoading({ reserve: false });

      setCheckTrems(true)
      setTimeout(() => {
        setCheckTrems(false)
      }, 2000);
      
      return;
    }
    let obj = {
      item_id: basket.item.id,
      type_payment: kindF,
    };
    if (basket.offer && basket.offer.status) {
      obj.offer_code = basket.offer.offer_code;
    }

    // if (basket.otherpeopel.length > 1) {
    //   obj.otherpeopel = basket.otherpeopel.filter(item => {
    //     if (!item.self) {
    //       return item;
    //     }
    //   });
    // }
    if (basket.type && basket.type == "contract") {
      obj.times = basket.timesApi;
      obj.date_end = basket.date_end;
      obj.date_start = basket.date_start;
    } else {
      obj = {
        ...obj, timekey: basket.time.id, daykey: basket.time.daykey,
        count: basket.count, childcount: basket.childcount,
        reqball: basket.reqball ? basket.reqball : false
      };
    }
    return await Get({
      url:
        basket.type && basket.type == "contract"
          ? "/order/new_contractual_reserve"
          : "/order/new_reserve",
      data: { ...obj },
      stat: true,
    }).then(data => {
      if (data.data) {
        if (kindF === "wallet") {
          dispatch({
            local_storage: {
              key: "basket",
            },
            payload: "basket",
            type: "REMOVE",
          });
          if (data) {
            window.location.replace(data.data.url);
          }
        } else if (kindF == "gateway" && data.data && data.data.url) {
          dispatch({
            local_storage: {
              key: "basket",
            },
            payload: "basket",
            type: "REMOVE",
          });
          window.location.replace(data.data.url);
        }
      }
      setLoading({ reserve: false });
    });
  };
  const handleChange = async ({ target: { name, value, id } }) => {
    let otherpeopel = [...basket.otherpeopel].map(people => {
      if (people.id === id) {
        if (name === "brday") {
          return { ...people, [name]: dateInputYMD(value) };
        }
        return { ...people, [name]: value };
      } else {
        return people;
      }
    });
    await dispatch({
      local_storage: {
        key: "basket",
        value: { ...basket, otherpeopel },
      },
      type: "SET",
      payload: { basket: { ...basket, otherpeopel } },
    });
  };
  const checkOffer = async offer_code => {
    setLoading({ ...loading, offer: true });
    let obj = {
      item_id: basket.item.id,
      timekey: basket.time.id,
      daykey: basket.time.daykey,
      offer_code,
    };
    if (basket.otherpeopel.length > 1) {
      obj.otherpeopel = basket.otherpeopel.filter(item => {
        if (!item.self) {
          return item;
        }
      });
    }
    await Get({
      url: "/off/check",
      data: { ...obj },
      stat: true,
    }).then(data => {
      if (data.data) {
        dispatch({
          local_storage: {
            key: "basket",
            value: {
              ...basket,
              offer: { ...data.data, status: true, offer_code },
            },
          },
          type: "SET",
          payload: {
            basket: {
              ...basket,
              offer: { ...data.data, status: true, offer_code },
            },
          },
        });
      }
      setLoading({ ...loading, offer: false });
    });
  };
  const totalPrice = () => {
    if (basket.offer && basket.offer.status) {
      return basket.offer.new_total_price;
    } else {
      if (basket.time.second_price) {
        return +basket.time.second_price * basket.otherpeopel.length;
      } else {
        return +basket.time.price * basket.otherpeopel.length;
      }
    }
  };

  const natCodeHandler = (el) => {
    const code = el.target.value
    if (code.length == 10) {
      setNtCodeStatus(code)
    }
    else {
      setNtCodeStatus(null)
    }
  };

  return {
    changeCount,
    renderBasketStatus,
    clearBasket,
    createPartners,
    changeStep,
    storeReserve,
    handleChange,
    addPromise,
    addBall,
    checkOffer,
    code,
    setCode,
    totalPrice,
    kind,
    setKind,
    loading,
    balance,
    userInfo,
    natCodeHandler,
    ntCodeStatus,
    checkTrems
  };
};
